import { monitoringApi } from "@/core/apis";
import { vehicleTreeGrid_generateUniqueId } from "@/assets/js/components/XVehicleTreeGrid";

// getter types
export const ARBAEEN_TREE_DATA = "arbaeenTreeData";

// action types
export const GET_ARBAEEN_TREE_DATA = "getArbaeenTreeData";
export const PURGE_ARBAEEN_TREE_DATA = "purgeArbaeenTreeData";

// mutation types
const SET_ARBAEEN_TREE_DATA = "setArbaeenTreeData";
const SET_PURGE_ARBAEEN_TREE_DATA = "setPurgeArbaeenTreeData";

const state = {
  arbaeenTreeData: []
};

const getters = {
  [ARBAEEN_TREE_DATA](state) {
    return state.arbaeenTreeData;
  }
};

const actions = {
  [GET_ARBAEEN_TREE_DATA](context) {
    return new Promise(resolve => {
      monitoringApi.arbaeenGetFences().then(response => {
        context.commit(SET_ARBAEEN_TREE_DATA, response.items);
        resolve();
      });
    });
  },
  [PURGE_ARBAEEN_TREE_DATA](context) {
    context.commit(SET_PURGE_ARBAEEN_TREE_DATA);
  }
};

const mutations = {
  [SET_ARBAEEN_TREE_DATA](state, arbaeenTreeData) {
    // Add Iran
    arbaeenTreeData.unshift({
      id: 0,
      name: "ایران",
      gpS_ID: null,
      parentID: null,
      level: 0,
      description: null,
      isActive: true
    });
    // **************************************************
    const formatted = arbaeenTreeData.map(c => ({
      extra: {
        name: c.name,
        gpS_ID: null,
        parentID: c.id === 0 ? null : 0,
        descriptions: null
      },
      isActive: true,
      hasChildren: false,
      selected: false,
      id: c.id,
      level: c.id === 0 ? 0 : 1,
      uniqueId: vehicleTreeGrid_generateUniqueId(c.id, c.id === 0 ? 0 : 1),
      parentUniqueId:
        c.id === 0 ? null : vehicleTreeGrid_generateUniqueId(0, 0),
      polygons: c.polygons ?? []
    }));

    for (let index = 0; index < formatted.length; index++) {
      const element = formatted[index];
      element.hasChildren = formatted.some(
        q => q.parentUniqueId === element.uniqueId
      );

      element.extra.vehicleCount = null;
    }

    state.arbaeenTreeData = [...formatted];
  },
  [SET_PURGE_ARBAEEN_TREE_DATA](state) {
    state.arbaeenTreeData = [];
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
